<template>
  <div class="lang-select js-lang-select" @click="toggleSelect">
    <div class="lang-select-selected" :class="selectedLocale.class">
      {{ selectedLocale.name }}
    </div>
    <ul class="lang-select-list">
      <li v-for="locale in locales"
          :key="locale.id"
          :data-id="locale.id"
          class="js-lang-select-item"
          @click="selectLang"
      >
        <span :class="locale.class">{{ locale.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import {i18n, setLocale} from "@/i18n/i18";

function findParentWithClass(el, clazz) {
  let parent = el

  while (parent) {
    if (parent.classList.contains(clazz)) return parent
    parent = parent.parentElement
  }
}

const locales = [
  {
    id: "ru",
    name: "rus",
    class: ["lang-select-item", "lang-select-item__ru"],
  },
  {
    id: "en",
    name: "eng",
    class: ["lang-select-item", "lang-select-item__en"],
  },
];

function getLocale(id) {
  for (let locale of locales) {
    if (locale.id === id) return locale;
  }
}

function getLocales(selectedId) {
  return locales.filter((locale) => {
    return locale.id !== selectedId
  });
}

export default {
  name: "LangBtn",
  methods: {
    toggleSelect: function (event) {
      let select = findParentWithClass(event.target, 'js-lang-select');
      if (!select) return;

      select.classList.toggle('is-active');
    },
    selectLang: function (event) {
      let langItem = findParentWithClass(event.target, 'js-lang-select-item')
      if (!langItem) return;

      this.selectedLangId = langItem.dataset.id;
      setLocale(langItem.dataset.id);
      this.toggleSelect(event);
    },
  },
  data: () => {
    return {
      selectedLangId: i18n.locale,
    }
  },
  computed: {
    selectedLocale: function () {
      return getLocale(this.selectedLangId);
    },
    locales: function () {
      return getLocales(this.selectedLangId);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/colors";

@mixin flag($url) {
  &::before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url($url);
    margin-right: 7px;
  }
}

.lang-select {
  position: relative;
  margin-left: 16px;
  z-index: 1;
  text-transform: none;

  &-selected {
    display: flex;
    align-items: center;
    padding-right: 20px;

    &::after {
      position: absolute;
      right: 6px;
      top: calc(50% - 5.5px);
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-style: solid;
      border-color: $white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      transform-origin: 60% 60%;
      transition: .1s transform;
    }

    .is-active > &::after {
      transform: rotate(225deg);
    }
  }

  &-list {
    position: absolute;
    top: 100%;
    display: none;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    background: $black;

    .is-active > & {
      display: block;
    }
  }

  &-item {
    display: flex;
    align-items: center;
    color: $white;
    font-family: "Circe", sans-serif;
    font-weight: normal;
    font-size: 16px;
    cursor: pointer;

    &__en {
      @include flag('./icons/flag_uk.svg');
    }

    &__ru {
      @include flag('./icons/flag_ru.svg');
    }
  }
}
</style>